import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { customLessonCountForClassAtomFamily } from './customLessons.atoms'

export function useCustomLessonCountForClass(classId: number) {
  return useAtom(customLessonCountForClassAtomFamily(classId))
}
